var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-toolbar',{staticClass:"table-toolbar",attrs:{"flat":"","height":"26"}},[_c('v-spacer'),_c('v-toolbar-items',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }